import * as React from 'react';
import { ChartsWrapper, ChartWrapper, FeatureChart, SmallChart, TrendChart } from './ChartsStyles';
import { language } from './ChartsLanguage';
import { useLayoutEffect } from 'react';
import { multiseriesBar } from './individualCharts/multiseriesBar';
import { consolePie } from './individualCharts/pieChart';
import { stackedCategoryTop3 } from './individualCharts/stackedBar';
import { trendForecast } from './individualCharts/trendForecast';
import { shapImpactChart } from './individualCharts/shap';
import { juiceBars } from './individualCharts/orangeJuice';

export type Props = {};

export const ChartsLayout = (props: Props) => {
	useLayoutEffect(() => juiceBars('pieChartDiv'), []);
	// useLayoutEffect(() => trendForecast('other'), []);
	useLayoutEffect(
		() =>
			shapImpactChart({
				divId: 'other',
				title: 'Console Prediction — SHAP Impact',
				data: [
					{ feature: 'tag:brand=Nintendo', shap: 0.62 },
					{ feature: 'days_since_launch', shap: 0.39 },
					{ feature: 'discount_pct', shap: 0.21 },
					{ feature: 'competitor_launches', shap: -0.15 },
					{ feature: 'inventory_in_stock_ratio', shap: 0.12 },
					{ feature: 'macro:cci', shap: -0.07 },
				],
				topN: 8,
			}),
		[]
	);
	// useLayoutEffect(() => consolePie('other3'), []);
	useLayoutEffect(() => stackedCategoryTop3('stackedBarDiv'), []);

	const render = () => {
		const returnValue = (
			<ChartsWrapper>
				<FeatureChart>
					<div
						id="stackedBarDiv"
						style={{
							width: '100%',
							height: '100%',
						}}
					/>
				</FeatureChart>
				<FeatureChart>
					<div
						id="pieChartDiv"
						style={{
							width: '100%',
							height: '100%',
						}}
					/>
				</FeatureChart>
				<TrendChart>
					<div
						id="other"
						style={{
							width: '100%',
							height: '100%',
						}}
					/>
				</TrendChart>
			</ChartsWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
